export default class AsyncAjax{
    public static async Post<t>(url:string,data:any={}):Promise<t>
    {
        return new Promise<t>((resolve)=>{
            jQuery.post(url,data,resolve,'json');
        });
    }

    public static async CancellablePost<t>(url:string,data:any={},cancelationToken:CancellationToken):Promise<t>
    {
        return new Promise<t>((resolve)=>{
            jQuery.post(url,data,(data)=>{
                if(!cancelationToken.WasCancelled)
                    resolve(data);
            },'json');
        });
    }

}

export class CancellationToken{
    private _cancel:boolean=false;
    public Cancel(){
        this._cancel=true;
    }

    get WasCancelled(){
        return this._cancel;
    }
}


// WEBPACK FOOTER //
// C:/wamp/www/node_modules/rednao-async-ajax/index.tsx